var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 3a3 3 0 0 1 6 0v1h.5A2.5 2.5 0 0 1 12 6.5v3A2.5 2.5 0 0 1 9.5 12h-7A2.5 2.5 0 0 1 0 9.5v-3A2.5 2.5 0 0 1 2.5 4H3zm5 0v1H4V3a2 2 0 1 1 4 0M1 6.5A1.5 1.5 0 0 1 2.5 5h7A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5zm5.5 0a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0z",
    clipRule: "evenodd"
  })));
});
const SvgLocksmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocksmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDNDMyAxLjM0MzE1IDQuMzQzMTUgMCA2IDBDNy42NTY4NSAwIDkgMS4zNDMxNSA5IDNWNEg5LjVDMTAuODgwNyA0IDEyIDUuMTE5MjkgMTIgNi41VjkuNUMxMiAxMC44ODA3IDEwLjg4MDcgMTIgOS41IDEySDIuNUMxLjExOTI5IDEyIDAgMTAuODgwNyAwIDkuNVY2LjVDMCA1LjExOTI5IDEuMTE5MjkgNCAyLjUgNEgzVjNaTTggM1Y0SDRWM0M0IDEuODk1NDMgNC44OTU0MyAxIDYgMUM3LjEwNDU3IDEgOCAxLjg5NTQzIDggM1pNMSA2LjVDMSA1LjY3MTU3IDEuNjcxNTcgNSAyLjUgNUgzLjVIOC41SDkuNUMxMC4zMjg0IDUgMTEgNS42NzE1NyAxMSA2LjVWOS41QzExIDEwLjMyODQgMTAuMzI4NCAxMSA5LjUgMTFIMi41QzEuNjcxNTcgMTEgMSAxMC4zMjg0IDEgOS41VjYuNVpNNi41IDYuNUM2LjUgNi4yMjM4NiA2LjI3NjE0IDYgNiA2QzUuNzIzODYgNiA1LjUgNi4yMjM4NiA1LjUgNi41VjkuNUM1LjUgOS43NzYxNCA1LjcyMzg2IDEwIDYgMTBDNi4yNzYxNCAxMCA2LjUgOS43NzYxNCA2LjUgOS41VjYuNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";